export enum TitleTag {
	H1 = "h1",
	H2 = "h2",
	H3 = "h3",
	H4 = "h4",
	H5 = "h5",
	H6 = "h6",
}

export enum TitleColor {
	Black = "black",
	Green = "green",
}

export type TitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
	content: string;
	color?: TitleColor;
	tag?: TitleTag;
	className?: string;
}

export type DefaultTitleProps = {
	content: NonNullable<TitleProps['content']>;
	color: NonNullable<TitleProps['color']>;
	tag: NonNullable<TitleProps['tag']>;
	className: NonNullable<TitleProps['className']>;
}

export const defaultProps: TitleProps = {
	content: "",
	color: TitleColor.Black,
	tag: TitleTag.H1,
	className: "",
};
